export default __webpack_public_path__ + "21feb6434ff88c7b38aaf9ff0e23e985.png";